import React from "react";
import { Grid, Skeleton } from "@mui/material";
import BillingOverview from "components/src/components/displayDataComponents/wallet/BillingOverview/BillingOverview";
import AccountBalance from "components/src/components/displayDataComponents/wallet/AccountBalance/AccountBalance";
import PaymentInfo from "components/src/components/displayDataComponents/wallet/PaymetInfo/PaymentInfo";
import TransactionHistoryTable from "components/src/components/displayDataComponents/TransactionHistoryTable";
import { withApi } from "../hoc/ApiProvider/Provider";
import { useEffect } from "react";
import { useState } from "react";
import {
  AccountBalanceProps,
  BillingResponse,
  TransactionProps,
} from "components/src/components/displayDataComponents/wallet/BillingOverview/types";
import { camelToSnackCase } from "components/src/utils/helpers";
import exportFromJSON from "export-from-json";
import { string } from "prop-types";
import { RedeemCouponResponse } from "components/src/components/formComponents/PromoCodeForm";

const BillingPage = (props: any) => {
  const [loadingBilling, setLoadingBilling] = useState<boolean>(true);
  const [loadingBalance, setLoadingBalance] = useState<boolean>(true);
  const [loadingTransactionHistory, setLoadingTransactionHistory] =
    useState<boolean>(true);
  const [billingOverViewData, setBillingOverViewData] = useState<
    TransactionProps[] | null
  >(null);

  const [exchangeData, setExchangeData] = useState<{
    amount: number;
    currencyAmount: number;
    exchangeRate: number;
  } | null>(null);
  const [listBalance, setListBalance] = useState<AccountBalanceProps | null>(
    null
  );
  const [transactionHistory, setTransactionHistory] = useState<any | null>(
    null
  );

  const [transactionHistoryFilter, setTransactionHistoryFilter] = useState({
    limit: 5,
    offset: 0,
  });

  const [billingOverviewFilter, _] = useState({
    filters: [
      {
        field: "transaction_type",
        condition: "FILTER_CONDITION_EQ",
        value: {
          "@type": "type.googleapis.com/google.protobuf.Value",
          value: "payment",
        },
      },
    ],
  });
  const [transactionOrderBy, setTransactionOrderBy] =
    useState<string>("created_at desc");

  const listBillingOverView = () => {
    props.api
      .getBillingOverView(billingOverviewFilter)
      .then(
        (data: BillingResponse) => setBillingOverViewData(data.data),
        setLoadingBilling(false)
      )
      .catch(() => {
        setLoadingBilling(false);
      });
  };
  const listBalanceAccount = () => {
    props.api
      .getBalance()
      .then((res: AccountBalanceProps) => {
        setListBalance(res), setLoadingBalance(false);
      })
      .catch(() => {
        setLoadingBalance(false);
      });
  };
  const listTransactionHistory = () => {
    props.api
      .getTransactionHistory({
        pagination: transactionHistoryFilter,
        orderBy: transactionOrderBy,
      })
      .then(
        (res: any) => setTransactionHistory(res),
        setLoadingTransactionHistory(false)
      )
      .catch(() => {
        setLoadingTransactionHistory(false);
      });
  };
  useEffect(() => {
    listBillingOverView();
    listBalanceAccount();
  }, [props.api]);
  const handlePayment = () => {
    props.api.getBillingPortal().then((res: { url: string }) => {
      window.open(res.url, "_blank");
    });
  };
  useEffect(() => {
    listTransactionHistory();
  }, [
    transactionHistoryFilter.offset,
    transactionHistoryFilter.limit,
    transactionOrderBy,
  ]);
  const addOrderFilterTransaction = (data: any) => {
    const convertedString = camelToSnackCase(data);
    const currentTransactionOrder: string[] = transactionOrderBy.split(" ");
    const changeOrderByString = calculateOrder(
      currentTransactionOrder,
      convertedString
    );
    setTransactionOrderBy(changeOrderByString);
  };
  const calculateOrder = (value: string[], columnName: string) => {
    if (columnName === "currency_amount") {
      columnName = "amount";
    }
    if (value[1] === "asc") {
      value[1] = "desc";
      value[0] = columnName;
      return `${value[0]} ${value[1]}`;
    } else {
      value[1] = "asc";
      value[0] = columnName;
      return `${value[0]} ${value[1]}`;
    }
  };
  const exportAllTransactionCsv = async () => {
    const response = await props.api.getAllTransactionCsv();
    if (response.csv) {
      const lines = response.csv.split("\n");

      const headers = lines[0].split(",");

      const jsonData = lines.slice(1).map((line: any) => {
        const values = line.split(",");
        return headers.reduce((acc: any, header: any, index: any) => {
          acc[header.trim()] = values[index]?.trim();
          return acc;
        }, {});
      });
      const exportType = exportFromJSON.types.csv;
      const fileName = "transactions";
      exportFromJSON({ data: jsonData, fileName, exportType });
    }
  };

  const handleExchangeFn = async (data: number) => {
    const response = await props.api.getExchangeRate("USD", 1, data);
    if (response) {
      setExchangeData({
        amount: response.amount,
        currencyAmount: response.currencyAmount,
        exchangeRate: response.exchangeRate,
      });
    }
  };
  const redeemCouponFn = async (code: any): Promise<RedeemCouponResponse> => {
    const response = await props.api.redeemPromoCode(code);
    return {
      amount: parseFloat(response.amount || "0"),
      code: response.code || "",
      id: response.id || "",
    };
  };
  const onTopUpRequest = async (currency: string, amount: number) => {
    const resp = await props.api.createTopUpRequest(currency, amount);
    return {
      amount: parseFloat(resp.topUpRequest?.amount || "0"),
      currencyAmount:
        parseFloat(resp.topUpRequest?.currencyAmount || "0") / 100,
      clientSecret: resp.clientSecret || "",
      currency: resp.topUpRequest?.currency || "USD",
    };
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {loadingBilling ? (
          <Skeleton width={"100%"} height={"20rem"} />
        ) : (
          <BillingOverview
            title={"Billing Overview"}
            transactions={billingOverViewData}
          />
          //change the account
        )}
      </Grid>
      <Grid item xs={12} md={6}>
        {loadingBalance ? (
          <Skeleton width={"100%"} height={"20rem"} />
        ) : (
          <AccountBalance
            balance={listBalance?.totalBalance}
            amountDue={listBalance?.amountDue}
            handelExchangeFn={handleExchangeFn}
            exchangeRateData={exchangeData}
            setExchangeRate={setExchangeData}
            onRedeemCoupon={redeemCouponFn}
            onTopUpRequest={onTopUpRequest}
          />
        )}
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0,
          m: 0,
        }}
      >
        <PaymentInfo handleClick={handlePayment} />
      </Grid>
      <Grid item xs={12}>
        {loadingTransactionHistory ? (
          <Skeleton
            width={"100%"}
            height={"20rem"}
            sx={{
              mb: 1,
            }}
          />
        ) : (
          <TransactionHistoryTable
            data={transactionHistory?.data}
            handleExportCsv={exportAllTransactionCsv}
            pagination={transactionHistory?.pagination}
            limitFilter={props.api.getDefaultLimitFilters()}
            addOrderFilterTransaction={addOrderFilterTransaction}
            transactionHistoryFilterChange={setTransactionHistoryFilter}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default withApi(BillingPage);
